import React from 'react';
import Parse from 'parse';
import { Alert, Button } from '@mui/material';
import { insightCsv, loadInsights } from './insightsModel';
import InsightsView from './InsightsView';

function InsightsWorkspace() {
  const [days, setDays] = React.useState(30);
  const [report, setReport] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');
  const [retry, setRetry] = React.useState(0);
  React.useEffect(() => {
    let current = true;
    setLoading(true);
    setError('');
    loadInsights((name, params) => Parse.Cloud.run(name, params), {
      days,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    })
      .then((result) => {
        if (current) setReport(result);
      })
      .catch(() => {
        if (current)
          setError('Insights could not be refreshed. Please try again.');
      })
      .finally(() => {
        if (current) setLoading(false);
      });
    return () => {
      current = false;
    };
  }, [days, retry]);
  const exportReport = () => {
    if (!report) return;
    const url = URL.createObjectURL(
      new Blob([insightCsv(report)], { type: 'text/csv;charset=utf-8' })
    );
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = `lifetagger-insights-${report.days}-days.csv`;
    anchor.click();
    URL.revokeObjectURL(url);
  };
  return (
    <InsightsView
      report={report}
      days={days}
      loading={loading}
      error={error}
      onRetry={() => setRetry((value) => value + 1)}
      onPeriod={setDays}
      onExport={exportReport}
    />
  );
}

export class InsightsBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    if (this.state.failed)
      return (
        <div className="lt-overview">
          <h1 className="lt-page-title">Insights.</h1>
          <Alert
            severity="error"
            action={
              <Button
                color="inherit"
                onClick={() => this.setState({ failed: false })}
              >
                Retry
              </Button>
            }
          >
            This report could not be displayed. Your other dashboard pages are
            still available.
          </Alert>
        </div>
      );
    return this.props.children;
  }
}
export default function InsightsPage() {
  return (
    <InsightsBoundary>
      <InsightsWorkspace />
    </InsightsBoundary>
  );
}
